import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./pages/Home/Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PortfolioDetails from "./pages/PortfolioDetails/PortfolioDetails";
import Footer from "./pages/shared/Footer/Footer";
import NavMenu from "./pages/shared/NavMenu/NavMenu";
import Blogs from "./pages/Blogs/Blogs";
import PageNotFound from "./pages/PageNotFound/PageNotFound";
import Blog1 from "./pages/Blogs/Blog/Blog1";
import Blog2 from "./pages/Blogs/Blog/Blog2";
import AOS from "aos";
import "aos/dist/aos.css";
import Blog3 from "./pages/Blogs/Blog/Blog3";
import Blog4 from "./pages/Blogs/Blog/Blog4";
import Blog5 from "./pages/Blogs/Blog/Blog5";

function App() {
  return (
    <div className="App">
      <Router>
        <NavMenu />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/home">
            <Home />
          </Route>
          <Route path="/details/:portfolioId">
            <PortfolioDetails />
          </Route>
          <Route path="/blogs">
            <Blogs />
          </Route>
          <Route path="/blog_one">
            <Blog1 />
          </Route>
          <Route path="/blog_two">
            <Blog2 />
          </Route>
          <Route path="/blog_three">
            <Blog3 />
          </Route>
          <Route path="/blog_four">
            <Blog4 />
          </Route>
          <Route path="/blog_five">
            <Blog5 />
          </Route>
          <Route path="*">
            <PageNotFound />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
